import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useContext, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  CONFIG_TAG_TABS,
  DEFAULT_TAGS_CONFIG_SUBTYPE,
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
  TAGS_CONFIG_SUBTYPES,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import Portal from '../../../../../components/Portal';
import ConfigTagsTable from '../components/ConfigTagsTable';
import ConfigTagsTabs from '../components/ConfigTagsTabs';

const TAB_ROUTES = {
  [TAGS_CONFIG_SUBTYPES?.USERS
    ?.value]: `${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_USERS}`,
  [TAGS_CONFIG_SUBTYPES?.ORDERS
    ?.value]: `${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_ORDERS}`,
  [TAGS_CONFIG_SUBTYPES?.REVIEW
    ?.value]: `${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_REVIEW}`,
  [TAGS_CONFIG_SUBTYPES?.INVENTORY
    ?.value]: `${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TAGS_INVENTORY}`,
};

const ConfigTags = ({ initialTab }) => {
  const history = useHistory();
  const {
    state: { permissions },
  } = useContext(AppContext);

  const activeTagTabKey = initialTab || DEFAULT_TAGS_CONFIG_SUBTYPE;

  const handleTabChange = (key) => {
    if (TAB_ROUTES[key]) {
      history.push(TAB_ROUTES[key]);
    }
  };
  const [isTagModalOpen, setIsTagModalOpen] = useState(false);
  const [currentTag, setCurrentTag] = useState(null);

  const addTagButtonLabel = useMemo(() => {
    const tab = Object.values(CONFIG_TAG_TABS).find(
      (t) => t.key === activeTagTabKey,
    );
    const scope = tab?.label || 'Tag';
    return `Add ${scope} Tag`;
  }, [activeTagTabKey]);

  const canCreateTag = hasPermission(
    PERMISSIONS_KEY?.MASTER_LIST_TAG,
    PERMISSION_TYPE?.CREATE,
    permissions,
  );

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.TAGS}</div>
      </Portal>

      <Portal portalId="header-right-content">
        {canCreateTag && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsTagModalOpen(true);
              setCurrentTag(null);
            }}
          >
            {addTagButtonLabel}
          </Button>
        )}
      </Portal>

      <Portal portalId="header-right-content-phones">
        {canCreateTag && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsTagModalOpen(true);
              setCurrentTag(null);
            }}
          >
            {addTagButtonLabel}
          </Button>
        )}
      </Portal>

      {/* Same layout as Orders > All: tabs are not wrapped in Card so `.card-container` card-tabs match portal layout */}
      <ConfigTagsTabs activeKey={activeTagTabKey} onChange={handleTabChange}>
        <div className="tab-table">
          <ConfigTagsTable
            configSubtype={activeTagTabKey}
            isTagModalOpen={isTagModalOpen}
            setIsTagModalOpen={setIsTagModalOpen}
            currentTag={currentTag}
            setCurrentTag={setCurrentTag}
            addTagModalScopeLabel={
              Object.values(CONFIG_TAG_TABS).find(
                (t) => t.key === activeTagTabKey,
              )?.label
            }
          />
        </div>
      </ConfigTagsTabs>
    </>
  );
};

export default ConfigTags;
